import * as React from 'react';
import { Messages } from '../../../codegen/Localize';
import { BrowserTitleService } from '../../../commonInfra/services/BrowserTitleService';
import { SpaceContainerStyles } from '../../../style/SpaceContainerStyles';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { ProjectDefinition } from '../../../ts/models/ContentDefinitions';
import { ExplorableItemType } from '../../../ts/models/ContentType';
import { SpaceType } from '../../state/SpaceInfo';
import { ConnectedExplorer } from '../Explorer/ConnectedExplorer';
import { ExplorerStyles } from '../Explorer/ExplorerStyles';
import { ExplorerEmptyStateProps } from '../Components/ExplorerEmpyState';

const testIdPrefix = 'personal-space';
const EMPTY_STATE_TEST_ID = `${testIdPrefix}-empty-state`;

export interface PersonalSpaceOwnProps extends ReactDirectiveProps {
}

export interface PersonalSpaceStateProps {
  readonly contentTypeFilterValues: ReadonlyArray<ExplorableItemType>;
  readonly defaultContentTypeFilterValues: ReadonlyArray<ExplorableItemType>;
}

export interface PersonalSpaceDispatchProps {
  readonly requestSpaceContents: () => void;
  readonly filterSelected: (selectedItems: ArrayLike<ExplorableItemType>) => void;
  readonly clearContentCounts: (spaceType: SpaceType) => void;
}

export type PersonalSpaceProps = PersonalSpaceStateProps
  & PersonalSpaceDispatchProps
  & PersonalSpaceOwnProps;

export class PersonalSpace extends React.PureComponent<PersonalSpaceProps> {

  public componentDidMount() {
    BrowserTitleService.setTitleWithPlaceEntityName({ placeEntityName: Messages.personalSpaceTitle() });
    this.props.requestSpaceContents();
  }

  public render(): JSX.Element {
    return (
      <div className={SpaceContainerStyles.SpaceContainer}>
        <div className={SpaceContainerStyles.MastheadArea}>
          <div className={ExplorerStyles.SpaceHeaderContent}>
            <div className={ExplorerStyles.SpaceHeaderText}>{Messages.personalSpaceTitle()}</div>
          </div>
          <div style={SpaceContainerStyles.MastheadSubheadingArea}>
            {Messages.personalSpaceMastheadSubheading()}
          </div>
        </div>
        <div className={SpaceContainerStyles.SubplaceArea}>
          <ConnectedExplorer
            angularContext={this.props.angularContext}
            supportedDisplayModes={ProjectDefinition.supportedDisplayModes}
            emptyStateProps={this.emptyStateProps()}
            toolbarProps={{
              supportFilterPanel: true,
              toolbarVisibility: 'enabled'
            }}
          />
        </div>
      </div>
    );
  }

  private emptyStateProps(): ExplorerEmptyStateProps {
    return {
      primaryMessage: Messages.personalSpaceEmptyStatePrimary(),
      secondaryMessage: Messages.personalSpaceEmptyStateSecondary(),
      dataTestId: EMPTY_STATE_TEST_ID,
      actionButtonMessage: Messages.personalSpaceEmptyStateActionButton(),
      onActionButton: () => {},
    };
  }
}